module.exports = __webpack_public_path__ + "static/media/Venus-berline-promo-banner.76c3d6fa.jpg";